import React, { useState, Suspense, lazy } from 'react';
import { useAuthStore } from '../store/authStore';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Check, Crown, Sparkles } from 'lucide-react';
const PaymentModal = lazy(() => import('../components/PaymentModal'));

const PLANS = [
  {
    id: 'monthly',
    name: 'Aylık',
    price: 299,
    period: 'ay',
    features: [
      'Sınırsız müşteri',
      'Sınırsız albüm',
      'Panoramik albüm sihirbazı',
      'Albümcü ağına erişim',
      'Baskı sipariş yönetimi',
      'E-posta desteği',
    ]
  },
  {
    id: 'yearly',
    name: 'Yıllık',
    price: 2990,
    period: 'yıl',
    badge: '2 ay BEDAVA',
    features: [
      'Aylık plandaki her şey',
      '🎁 2 ay ücretsiz (3.588₺ → 2.990₺)',
      'Öncelikli destek',
      'Yeni özelliklere erken erişim',
      'Özel raporlar',
    ],
    highlighted: true,
  }
];

export default function SubscriptionPage() {
  const { token, user } = useAuthStore();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showPayment, setShowPayment] = useState(false);

  const subStatus = user?.subscription_status || 'pending';
  const subEnd = user?.subscription_end;

  return (
    <div className="space-y-6 max-w-5xl mx-auto" data-testid="subscription-page">
      <div className="text-center">
        <h1 className="text-3xl font-bold flex items-center justify-center gap-2">
          <Crown className="h-7 w-7 text-amber-500" />
          Aboneliğinizi Seçin
        </h1>
        <p className="text-slate-500 mt-1">Sınırsız özelliklere erişin, işinizi büyütün</p>
      </div>

      {subStatus === 'active' && subEnd && (
        <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 text-center">
          <Sparkles className="h-6 w-6 text-emerald-600 mx-auto mb-1" />
          <div className="font-bold text-emerald-700">Aktif abonelik</div>
          <div className="text-sm text-slate-600">
            Bitiş tarihi: {new Date(subEnd).toLocaleDateString('tr-TR')}
          </div>
        </div>
      )}

      <div className="grid md:grid-cols-2 gap-4">
        {PLANS.map(plan => (
          <Card key={plan.id} data-testid={`plan-${plan.id}`}
            className={plan.highlighted ? 'ring-2 ring-primary shadow-xl' : ''}>
            <CardContent className="p-6">
              {plan.badge && (
                <div className="inline-block bg-amber-100 text-amber-700 text-xs font-bold px-2 py-1 rounded-full mb-2">
                  {plan.badge}
                </div>
              )}
              <h3 className="text-2xl font-bold">{plan.name}</h3>
              <div className="mt-2">
                <span className="text-4xl font-bold">{plan.price}</span>
                <span className="text-lg text-slate-500"> ₺/{plan.period}</span>
              </div>
              <ul className="mt-4 space-y-1.5">
                {plan.features.map((f, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm">
                    <Check className="h-4 w-4 text-emerald-500 mt-0.5 flex-shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>
              <Button className="w-full mt-5" size="lg"
                variant={plan.highlighted ? 'default' : 'outline'}
                onClick={() => { setSelectedPlan(plan); setShowPayment(true); }}
                data-testid={`buy-${plan.id}`}>
                {plan.price.toLocaleString('tr-TR')} ₺ / {plan.period} - Satın Al
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="text-center text-xs text-slate-500">
        Güvenli ödeme: 3D Secure · Taksit imkanı ödeme ekranında · İstediğiniz zaman iptal edebilirsiniz
      </div>

      {selectedPlan && (
        <Suspense fallback={null}>
          <PaymentModal
            open={showPayment}
            onOpenChange={setShowPayment}
            flow="subscription"
            amount={selectedPlan.price}
            title={`WeddingTakip ${selectedPlan.name} Abonelik`}
            meta={{ subscription_plan: selectedPlan.id }}
            token={token}
            onSuccess={() => {
              setTimeout(() => window.location.reload(), 1500);
            }}
          />
        </Suspense>
      )}
    </div>
  );
}
